/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-this-alias */

// Normally, I would address the linting issues, but I don't understand the
// original intent of this code well enough to do so safely. It feels like
// a hack to get around Angular's change detection... which is a code smell.
export function debounce(func: (...args: unknown[]) => void, wait: number) {
    let timeout: NodeJS.Timeout;
    return function () {
        const context = this,
            args = arguments;

        clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            func.apply(context, args);
        }, wait);
    };
}
